import { render } from "./Inscription_Item.vue?vue&type=template&id=36433458"
import script from "./Inscription_Item.vue?vue&type=script&lang=js"
export * from "./Inscription_Item.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__